import { create } from 'zustand';
import { PLAN_TYPE } from 'app/plan';

interface BuyerBrandState {
    taxInfo: TaxInfoResponse['data'] | null;
    cache: {
        pageSegment: Record<string, string>;
    };
    brandMeta: Brand | null;
    plan: PLAN_TYPE | null;
}

type Updater<T> = T | ((prev: T) => T);

export interface BuyerBrandAction {
    setTaxInfo: (taxInfo: TaxInfoResponse['data']) => void;
    setPageSegment: (updater: Updater<Record<string, string>>) => void;
    setBrandMeta: (brandMeta: Brand) => void;
    setPlan: (plan: PLAN_TYPE) => void;
}

export const useBuyerBrandStore = create<BuyerBrandState & BuyerBrandAction>((set) => ({
    taxInfo: null,
    brandMeta: null,
    cache: {
        pageSegment: {},
    },
    plan: null,
    setTaxInfo: (taxInfo) => set({ taxInfo }),
    setBrandMeta: (brandMeta) => set({ brandMeta }),
    setPlan: (plan) => set({ plan }),
    setPageSegment: (updater) => {
        set((state) => {
            const updates =
                typeof updater === 'function'
                    ? updater(state.cache.pageSegment)
                    : updater;

            const newCache = {
                ...state.cache,
                pageSegment: {
                    ...state.cache.pageSegment,
                    ...updates,
                },
            };

            return { cache: newCache };
        });
    },
}));
